import api from "../index";

export const GetAllBannersApi = (params) => api.get(`banner/get-all-banner?${params}`);
export const AddUpdateBannerApi = (data, headers) => api.post('banner/add-update-banner', data, headers);
export const DeleteBannerApi = (bannerId) => api.delete(`banner/delete-banner/${bannerId}`);
export const BannerStatusApi = (data) => api.put('banner/active-inactive-banner', data);
